import { Navigate } from "react-router";
import * as ROUTES from "../../../../constants/routes";
import { ReactNode } from "react";
import { useCheckout } from "./CheckoutProvider.shared";

export const EmptyBusinessBoundary = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { business } = useCheckout();

  if (!business) {
    return <Navigate to={ROUTES.SUPPLIERS} />;
  }

  return children;
};
